import {Component, Input} from "@angular/core";
import {CommonModule, NgClass} from "@angular/common";

@Component({
  selector: 'labeled-display',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './labeled-display.component.html'
})

export class LabeledDisplayComponent {
  @Input() type: string = 'text';
  @Input() value?: any;
  @Input() name: string = '';
  @Input() class: string | string[] | Set<string> | { [klass: string]: any } = 'form-control';
  @Input() style: string = '';
}
